import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PublicCategoriesState } from './public-categories.state';

export const selectPublicCategoriesState = createFeatureSelector<PublicCategoriesState>('publicCategories');

export const selectAllPublicCategories = createSelector(
  selectPublicCategoriesState,
  (state) => state.categories
);

export const selectPublicCategoriesLoading = createSelector(
  selectPublicCategoriesState,
  (state) => state.isLoading
);
